import React, { Component } from "react";
import PropTypes from "prop-types";

class NoticeMarquee extends Component {
  static propTypes = {
    message: PropTypes.string.isRequired,
    clearNotice: PropTypes.func.isRequired,
  };

  render() {
    if (!this.props.message.length) return null;

    return (
      <div style={styles.container} onClick={this.props.clearNotice}>
        {this.props.message}
      </div>
    );
  }
}

const styles = {
  container: {
    backgroundColor: "#eaf5e9",
    color: "#006702",
    border: "1px solid #bdd7bc",
    borderRadius: 3,
    padding: "10px 0 ",
    textAlign: "center",
    fontWeight: "bold",
    margin: "0 0 20px",
    fontFamily: "Arial, sans-serif",
    fontSize: "12px",
    textShadow: "0 1px 1px white",
  },
};
export default NoticeMarquee;
